"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-maria-a-monte": {
    "10a936b4": [{
      "hkey": "9e95b299",
      "slug": "falorni-fontine-pregiuntino",
      "name": "Falorni-Fontine-Pregiuntino",
      "primary": true,
      "skipSearch": false
    }],
    "falorni": [{
      "hkey": "9e95b299",
      "slug": "falorni-fontine-pregiuntino",
      "name": "Falorni-Fontine-Pregiuntino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "santa-maria-a-monte"
    }],
    "9ef3308b": [{
      "hkey": "9e95b299",
      "slug": "falorni-fontine-pregiuntino",
      "name": "Falorni-Fontine-Pregiuntino",
      "primary": true,
      "skipSearch": false
    }],
    "le-fontine": [{
      "hkey": "9e95b299",
      "slug": "falorni-fontine-pregiuntino",
      "name": "Falorni-Fontine-Pregiuntino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "santa-maria-a-monte"
    }],
    "1febb428": [{
      "hkey": "c0671373",
      "slug": "montecalvoli",
      "name": "Montecalvoli",
      "primary": true,
      "skipSearch": false
    }],
    "montecalvoli-in-alto": [{
      "hkey": "c0671373",
      "slug": "montecalvoli",
      "name": "Montecalvoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "santa-maria-a-monte"
    }],
    "f9dfd442": [{
      "hkey": "c0671373",
      "slug": "montecalvoli",
      "name": "Montecalvoli",
      "primary": true,
      "skipSearch": false
    }],
    "montecalvoli-in-basso": [{
      "hkey": "c0671373",
      "slug": "montecalvoli",
      "name": "Montecalvoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "santa-maria-a-monte"
    }],
    "459e45f6": [{
      "hkey": "9e95b299",
      "slug": "falorni-fontine-pregiuntino",
      "name": "Falorni-Fontine-Pregiuntino",
      "primary": true,
      "skipSearch": false
    }],
    "pregiuntino": [{
      "hkey": "9e95b299",
      "slug": "falorni-fontine-pregiuntino",
      "name": "Falorni-Fontine-Pregiuntino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;